module.exports = __webpack_public_path__ + "static/media/Articles_Hero_Desktop_1.5166a42a.png";